<script lang="ts">
  import IconLogin from '~icons/mdi/Login';
  import NavMenu from "./NavMenu.svelte";
  import { user } from "$lib/client/stores/nucamp-user";
  import Button from './ui/button/button.svelte';
  import NavMenuMobile from './NavMenuMobile.svelte';

  function handleError (event: any) {
    event.target.src = '/assets/imgs/users/anonymous.webp';
  }

</script>

<div class="bg-background sticky top-0 z-50">
  <div class="stripe-header">
    <div class="navbar text-foreground xl:py-4 md:px-0">
      <div class="navbar-start">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div class="dropdown">
          <div tabindex="0" role="button" class="btn btn-ghost lg:hidden">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="inline-block w-5 h-6 stroke-current"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
          </div>
          <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
          <NavMenuMobile class="menu menu-sm dropdown-content z-[1] p-2 shadow bg-base-100 min-w-80"/>
        </div>
        <a href="/home" class="max-lg:hidden">
          <div class="w-36">
            <img alt="Nucamp Logo" src="/assets/imgs/nucamp-logotype-only-color-vector.svg" />
          </div>
        </a>
      </div>
      <div class="navbar-center lg:flex">
        <a href="/home" class="lg:hidden">
          <div class="w-28">
            <img alt="Nucamp Logo" src="/assets/imgs/nucamp-logotype-only-color-vector.svg" />
          </div>
        </a>
        <NavMenu class="max-xl:hidden menu menu-horizontal px-1"/>
      </div>
      <div class="navbar-end">
        {#if $user}
          <a href="/home?profile=true">
            <div class="avatar">
              <div class="w-8 lg:w-10 rounded-full ring ring-slate-200 dark:ring-slate-200 ring-offset-base-100 shadow-nucamp-sm">
                <img src="{$user.photoURL}" alt="{$user.displayName}" on:error="{handleError}"/>
              </div>
            </div>
          </a>
        {:else}
        <Button href="/home?profile=true" class="bg-nucamp-light max-md:h-7 hover:bg-nucamp-light-hover dark:text-slate-100">Login <IconLogin class="max-lg:hidden pl-1 text-lg"></IconLogin></Button>
        {/if}
      </div>
    </div>
    <NavMenu class="max-lg:hidden xl:hidden menu menu-horizontal p-0 pb-4"/>
  </div>
</div>